<script lang="ts">
  import { AURAS, CLASSES, CLASS_IDS, type ClassId } from '@arena/shared';
  import { app, pickClasses } from '../lib/net.svelte';

  let { compact = false }: { compact?: boolean } = $props();

  /** A new class takes the place of the one picked longest ago; the second one picked again goes first. */
  function pick(id: ClassId) {
    const [first, second] = app.classes;
    if (id !== first) pickClasses(id === second ? [id, first] : [second, id]);
  }
</script>

<p class="muted small hint">
  Pick two classes. You start each match as your first, and Swap Class trades to
  the other.
</p>
<div class="class-grid" class:compact>
  {#each CLASS_IDS as id (id)}
    {@const cls = CLASSES[id]}
    {@const order = app.classes.indexOf(id)}
    <button
      class="class-card"
      class:selected={order >= 0}
      style="--class-color: {cls.color}"
      title={compact ? cls.description : undefined}
      aria-pressed={order >= 0}
      onclick={() => pick(id)}
    >
      {#if order >= 0}<span class="order">{order ? '2nd' : '1st'}</span>{/if}
      <img class="class-icon" src="/icons/{id}.webp" alt="" />
      <span class="class-copy">
        <strong>{cls.name}</strong>
        {#if !compact}<span class="small">{cls.description}</span>
          <span class="innate" title={AURAS[cls.innate].description}
            >{AURAS[cls.innate].name}: {AURAS[cls.innate].description}</span
          >{/if}
      </span>
    </button>
  {/each}
</div>

<style>
  .class-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
  .hint {
    margin: 0 0 8px;
  }
  .class-card {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    padding: 8px 12px 8px 8px;
    text-align: left;
    border-color: var(--border);
    background: #13151c;
  }
  .class-card .class-icon {
    flex: none;
    width: 72px;
    aspect-ratio: 1;
    object-fit: cover;
    border-radius: 3px;
  }
  .class-copy {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    min-width: 0;
  }
  .class-card strong {
    color: var(--class-color);
    font-size: 17px;
  }
  .order {
    position: absolute;
    top: 4px;
    right: 6px;
    font-size: 11px;
    font-weight: bold;
    color: var(--class-color);
  }
  .class-card.selected {
    border-color: var(--class-color);
    box-shadow: 0 0 12px color-mix(in srgb, var(--class-color) 50%, transparent);
  }
  .compact {
    grid-template-columns: repeat(4, 1fr);
  }
  .compact .class-card {
    flex-direction: column;
    align-items: center;
    gap: 6px;
    height: auto;
    padding: 8px 4px;
  }
  .compact .class-card .class-icon {
    width: 72px;
    height: auto;
    border-radius: 3px;
  }
  .compact .class-card strong {
    font-size: 15px;
  }
  .muted {
    color: var(--muted);
  }
  .small {
    font-size: 12px;
    line-height: 1.25;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    overflow: hidden;
  }
  .innate {
    font-size: 11px;
    line-height: 1.2;
    color: var(--gold);
  }
</style>
